import React from 'react';

function BoxHeader({className, icon, title, description, left, titleClassName="font-bold", descriptionClassName}) {
    return (
        <div className={`flex align-items-center gap-1 text-700 ${className?className:""}`}>
            <div className="flex-1 flex align-items-center gap-1">
                {icon}
                <div className="flex flex-column gap-1">
                    <span className={titleClassName}>{title}</span>
                    {description&&<span className={descriptionClassName}>{description}</span>}
                </div>
            </div>
            {left}
        </div>
    );
}

export default BoxHeader;